export class Uuid {

  protected _uuid: string;

  constructor(uuid?: string) {
    if (typeof (uuid) === 'undefined') {
      uuid = Uuid.generateId();
    }
    this._uuid = uuid;

    if (!Uuid.isValid(this._uuid)) {
      throw new RangeError(`Provided UUID "${this._uuid} is not valid`);
    }
  }

  /*************************/
  /* Public static methods */
  /*************************/

  public static generateId(): string {
    return "10000000-1000-4000-8000-100000000000".replace(/[018]/g, (c: string) =>
      (+c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> +c / 4).toString(16)
    );
  }

  public static isValid(uuid: string): boolean {
    return uuid.match(/^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i) ? true : false;
  }


  /***********/
  /* Getters */
  /***********/

  get value(): string {
    return this._uuid;
  }

  /******************/
  /* Public methods */
  /******************/

  /**
   * Checks the instance value is equal to another Uuid instance value.
   *
   * @param otherUuid UUID to compare to.
   */
  public equals(otherUuid: Uuid): boolean {
    return this._uuid === otherUuid.value;
  }
}
